import { memo } from 'react';
import PropTypes from 'prop-types';
import styles from './PartnerPhotoPlaceholder.scss';

export const PartnerPhotoPlaceholder = memo(({ children }) => (
  <figcaption className={styles.PhotoPlaceholder}>{children}</figcaption>
));

PartnerPhotoPlaceholder.displayName = 'PartnerPhotoPlaceholder';

PartnerPhotoPlaceholder.propTypes = {
  children: PropTypes.node.isRequired,
};
